// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DragAllDirectionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DragAllDirectionIcon" ref={forwardedRef} {...props}>
      <path d="M9 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path d="M9 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path d="M7.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
      <path d="M14 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path d="M14 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path d="M12.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    </SvgIcon>
  );
});

/**
 * Use to move an element independent of the direction
 * @public
 */
export const DragAllDirectionIcon = /* @__PURE__ */ Object.assign(
  DragAllDirectionIconComponent,
  { displayName: 'DragAllDirectionIcon' },
);
